import {Client, Repository} from "./client";
import * as URI from "urijs";
import Session from "session";

const browserURI = URI(window.location);
const configuration: any = {};

browserURI.hasQuery("octopus.server", (octopusServerURI: any) => {
    configuration.serverEndpoint = octopusServerURI;
});

const client = new Client(configuration);
const repository = new Repository(client);
const session = new Session();

export {client, repository, session};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/clientInstance.ts